import React from 'react'
import ContactForm from './ContactForm'
import Map from './Map'

const ContactMap = () => {
  return (
    <div>
        <h1 className="text-center mt-5 text-3xl font-bold">Contact</h1>
   
        <div className='flex w-[90%] mx-auto flex-col md:flex-row'>
            <ContactForm />
            <Map />
        </div>
    </div>
  )
}

export default ContactMap
